import { useUser } from "contexts";
import { arrayRemove, arrayUnion } from "firebase/firestore";
import { useState, useCallback } from "react";
import { updateUser } from ".";

/**
 * Hook para alternar favorito de una historia para el usuario actual.
 * @param {string} storyId - ID de la historia.
 * @returns {[boolean, function, boolean, any]}
 */
export const useToggleFavorite = (storyId) => {
  const { profile } = useUser();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isFavorite = profile.favorites?.includes(storyId);

  const toggleFavorite = useCallback(async () => {
    if (!storyId) return;

    setLoading(true);
    setError(null);

    updateUser({
      favorites: isFavorite ? arrayRemove(storyId) : arrayUnion(storyId),
    })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [storyId, isFavorite]);

  return [isFavorite, toggleFavorite, loading, error];
};
